import {CardContainer, CardTitleBox, ChipsBox, ClassesStatusBox, CollectionStatusChip} from '../Style/AutoProjectStatusBin.style';
import { CardContent, Subtitle1} from '../../../ui-library';
import React from 'react';
import {ChipStyle} from '../../../pages/AutoProject/Config/AutoProject.constants';

const AutoProjectStatusBinView = ({binTitle, chipsArr, chipStyle, childBtn = <></>, isChipsDisabled }) => (
    <CardContainer variant='outlined'>
        <CardContent>
            <CardTitleBox>
                <Subtitle1>
                    {binTitle}
                </Subtitle1>
                {childBtn}
            </CardTitleBox>
            <ClassesStatusBox>
                <ChipsBox>
                    {chipsArr.map((tag) => (
                        <CollectionStatusChip disabled={isChipsDisabled} key={tag.id}
                            chipstyle={tag.isError ? ChipStyle.Error : chipStyle}
                            label = {tag.tag_name}
                        />
                    ))}
                </ChipsBox>
            </ClassesStatusBox>
        </CardContent>
    </CardContainer>
);

export default AutoProjectStatusBinView;
